import { render } from "./Spinner.svg?vue&type=template&id=0f8434a6"
const script = {}
script.render = render

export default script